import { supabase } from '@/lib/supabase/client'
import { Educator, NewEducator } from '@/types/admin'

export const EducatorsService = {
  async getAll() {
    const { data, error } = await supabase
      .from('educators')
      .select('*')
      .order('created_at', { ascending: false })

    if (error) throw error
    return data as Educator[]
  },

  async create(educator: NewEducator) {
    console.log('Submitting form')

    // Ensure payload is pure JSON and serializable
    // We strictly avoid passing File objects or FormData here
    const payload = JSON.parse(JSON.stringify(educator))

    const { data, error } = await supabase
      .from('educators')
      .insert(payload)
      .select()
      .single()

    if (error) {
      console.error('DB insert failed:', error, payload)
      throw error
    }

    console.log('Educator saved successfully')
    return data as Educator
  },

  async update(id: string, updates: Partial<Educator>) {
    const { data, error } = await supabase
      .from('educators')
      .update(updates)
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return data as Educator
  },

  async delete(id: string) {
    const { error } = await supabase.from('educators').delete().eq('id', id)

    if (error) throw error
  },

  async uploadResume(file: File) {
    console.log('Upload started')

    // The file path must follow the pattern: resumes/{timestamp}-{original_filename}
    const timestamp = Date.now()
    // Sanitize filename to avoid some special characters issues but keep it recognizable
    // Replaced [^\x00-\x7F] with [^\x20-\x7E] to avoid eslint no-control-regex error and keep only printable ASCII
    const originalName = file.name.replace(/[^\x20-\x7E]/g, '')
    const filePath = `${timestamp}-${originalName}`

    const { error: uploadError } = await supabase.storage
      .from('resumes')
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false,
      })

    if (uploadError) {
      console.error('Upload failed:', uploadError)
      throw uploadError
    }

    const { data } = supabase.storage.from('resumes').getPublicUrl(filePath)

    console.log('Upload success:', data.publicUrl)
    return data.publicUrl
  },
}
